'use memo';

import { Outlet, createFileRoute, notFound } from '@tanstack/react-router';
import { Suspense } from 'react';
import { VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';
import { featureFlags } from '@/lib/env';
import { PoDetailHeader } from './-components/PoDetailHeader';

/**
 * PO Ledger（PO台帳）詳細画面のレイアウト。
 *
 * FE-1 で配線した PO_LEDGER feature flag が無効な環境では 404 にする
 * （`_list.tsx` と同様の挙動）。
 *
 * ヘッダ（導出4項目 + 最新版フラグ）+ タブストリップ（基本情報 / 発注明細）+
 * `<Outlet />` の3段構成（fe-impl-plan.md §6-1）。
 */
export const Route = createFileRoute('/_staff/po-ledger/$poId/_layout')({
  beforeLoad: () => {
    if (!featureFlags.check('PO_LEDGER')) {
      throw notFound();
    }
  },
  component: Layout
});
function PoDetailHeaderSkeleton() {
  return <VStack className="gap-3 bg-neutral-fill px-12 py-4 shadow-xs">
      <Skeleton className="h-4 w-40" />
      <VStack className="gap-2">
        <Skeleton className="h-5 w-24 rounded-full" />
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-96" />
      </VStack>
      <Skeleton className="h-6 w-48" />
    </VStack>;
}
function Layout() {
  return <VStack className="gap-0">
      <Suspense fallback={<PoDetailHeaderSkeleton />}>
        <PoDetailHeader />
      </Suspense>
      <Suspense fallback={<div className="flex-1 px-12 py-5" />}>
        <Outlet />
      </Suspense>
    </VStack>;
}